
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.1818 0H4.18182C2.98182 0 2 0.981818 2 2.18182V16.3636C2 16.9636 2.49091 17.4545 3.09091 17.4545C3.69091 17.4545 4.18182 16.9636 4.18182 16.3636V3.27273C4.18182 2.67273 4.67273 2.18182 5.27273 2.18182H16.1818C16.7818 2.18182 17.2727 1.69091 17.2727 1.09091C17.2727 0.490909 16.7818 0 16.1818 0ZM20.5455 4.36364H8.54545C7.34545 4.36364 6.36364 5.34545 6.36364 6.54545V21.8182C6.36364 23.0182 7.34545 24 8.54545 24H20.5455C21.7455 24 22.7273 23.0182 22.7273 21.8182V6.54545C22.7273 5.34545 21.7455 4.36364 20.5455 4.36364ZM19.4545 21.8182H9.63636C9.03636 21.8182 8.54545 21.3273 8.54545 20.7273V7.63636C8.54545 7.03636 9.03636 6.54545 9.63636 6.54545H19.4545C20.0545 6.54545 20.5455 7.03636 20.5455 7.63636V20.7273C20.5455 21.3273 20.0545 21.8182 19.4545 21.8182Z","fill":"#1B1B1B"}})])
          )
        }
      }
    